/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LiveStrokesGainedOverviewQueryVariables = {|
  eventId: string
|};
export type LiveStrokesGainedOverviewQueryResponse = {|
  +liveStrokesGainedOverview: ?{|
    +eventPlayers: ?$ReadOnlyArray<?{|
      +player: {|
        +id: string,
        +firstName: ?string,
        +lastName: ?string,
        +nameDisplay: string,
        +dkPlayer: ?{|
          +id: string
        |},
      |},
      +nextRoundSalary: ?number,
      +prettyEventToPar: ?string,
      +strokesGainedApproachTheGreen: ?any,
      +strokesGainedAroundTheGreen: ?any,
      +strokesGainedBallStriking: ?any,
      +strokesGainedIronPlay: ?any,
      +strokesGainedOffTheTee: ?any,
      +strokesGainedPutting: ?any,
      +strokesGainedShortGame: ?any,
      +strokesGainedTeeToGreen: ?any,
      +strokesGainedTotal: ?any,
      +currentPosition: ?string,
    |}>,
    +nextRoundSalaryTitle: ?string,
  |}
|};
export type LiveStrokesGainedOverviewQuery = {|
  variables: LiveStrokesGainedOverviewQueryVariables,
  response: LiveStrokesGainedOverviewQueryResponse,
|};
*/


/*
query LiveStrokesGainedOverviewQuery(
  $eventId: ID!
) {
  liveStrokesGainedOverview(eventId: $eventId) {
    eventPlayers {
      player {
        id
        firstName
        lastName
        nameDisplay
        dkPlayer {
          id
        }
      }
      nextRoundSalary
      prettyEventToPar
      strokesGainedApproachTheGreen
      strokesGainedAroundTheGreen
      strokesGainedBallStriking
      strokesGainedIronPlay
      strokesGainedOffTheTee
      strokesGainedPutting
      strokesGainedShortGame
      strokesGainedTeeToGreen
      strokesGainedTotal
      currentPosition
      id
    }
    nextRoundSalaryTitle
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PGATourPlayerType",
  "kind": "LinkedField",
  "name": "player",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PlayerType",
      "kind": "LinkedField",
      "name": "dkPlayer",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextRoundSalary",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyEventToPar",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokesGainedApproachTheGreen",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokesGainedAroundTheGreen",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokesGainedBallStriking",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokesGainedIronPlay",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokesGainedOffTheTee",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokesGainedPutting",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokesGainedShortGame",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokesGainedTeeToGreen",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokesGainedTotal",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentPosition",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextRoundSalaryTitle",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LiveStrokesGainedOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourLiveStrokesGainedOverviewType",
        "kind": "LinkedField",
        "name": "liveStrokesGainedOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourEventPlayerType",
            "kind": "LinkedField",
            "name": "eventPlayers",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LiveStrokesGainedOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourLiveStrokesGainedOverviewType",
        "kind": "LinkedField",
        "name": "liveStrokesGainedOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourEventPlayerType",
            "kind": "LinkedField",
            "name": "eventPlayers",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b16ebca73f014b1d837717c81e80dc06",
    "id": null,
    "metadata": {},
    "name": "LiveStrokesGainedOverviewQuery",
    "operationKind": "query",
    "text": "query LiveStrokesGainedOverviewQuery(\n  $eventId: ID!\n) {\n  liveStrokesGainedOverview(eventId: $eventId) {\n    eventPlayers {\n      player {\n        id\n        firstName\n        lastName\n        nameDisplay\n        dkPlayer {\n          id\n        }\n      }\n      nextRoundSalary\n      prettyEventToPar\n      strokesGainedApproachTheGreen\n      strokesGainedAroundTheGreen\n      strokesGainedBallStriking\n      strokesGainedIronPlay\n      strokesGainedOffTheTee\n      strokesGainedPutting\n      strokesGainedShortGame\n      strokesGainedTeeToGreen\n      strokesGainedTotal\n      currentPosition\n      id\n    }\n    nextRoundSalaryTitle\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4706808651b1b46ff3e0f9aef164301d';

module.exports = node;
